import React from "react";
import useTitle from "../hooks/UseTittle";

import { motion } from "framer-motion";

const Portfolio = () => {
  useTitle("Mofazzel | Works");

  const parentVariant = {
    hidden: {
      opacity: 0,
      x: 200,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.8,
        ease: [0, 0.71, 0.2, 1.01],
      },
    },
  };

  return (
    <>
      <motion.div
        variants={parentVariant}
        initial="hidden"
        animate="visible"
        className="sm:px-5 md:px-10 lg:px-14 bg-b-drop"
      >
        <div className="py-12">
          <h2 className=" after-effect after:left-48 lg:mt-0">Portfolio</h2>

          <ul className="button-group isotop-menu-wrapper mt-[30px] flex w-full justify-start md:justify-end flex-wrap font-medium">
            <li className="fillter-btn mr-4 md:mx-4 is-checked" data-filter="*">
              All
            </li>
            <li className="fillter-btn mr-4 md:mx-4" data-filter=".dev">
              Video
            </li>
            <li className="fillter-btn mr-4 md:mx-4" data-filter=".plugin">
              {" "}
              Web Design
            </li>
            <li className="fillter-btn mr-4 md:mx-4" data-filter=".branding">
              {" "}
              Logo
            </li>
            <li className="fillter-btn mr-4 md:mx-4" data-filter=".custom">
              Graphic Design
            </li>
          </ul>
        </div>
      </motion.div>
    </>
  );
};

export default Portfolio;
